import React from 'react';
import LiveMaterialTable from 'common/components/LiveMaterialTable';
import AddIcon from '@material-ui/icons/LibraryAdd';
import PrintIcon from '@material-ui/icons/Print'
import { calculateHeight } from '../../common/services/util';
import { getColorState } from '../services/config';
import TableTitle from 'common/components/TableTitle';

const TableStock = ({ columns, loading, data, onStockAdd, onStockUpdate, onStockDelete, onStockImport, handleStockPrint, textSearch, handleChangeTextSearch, tableRefProp }) => {
    return (
        <div className= "stateful-table">
            <LiveMaterialTable
                title={<TableTitle>Stock</TableTitle>}
                tableRef={tableRefProp}
                icons={{
                    'Add': () => <AddIcon fontSize='large' color='primary'></AddIcon>
                }}
                actions={[
                    {
                        icon: 'file_upload',
                        iconProps: { color: 'primary', fontSize: 'large' },
                        tooltip: 'Subir excel',
                        isFreeAction: true,
                        onClick: onStockImport
                    },
                    {
                        icon: () => <PrintIcon />,
                        onClick: (event, rowData) => handleStockPrint(rowData)
                    }
                ]}
                columns={columns}
                isLoading={loading}
                data={data}
                options={{
                    search: false,
                    sorting: true,
                    filtering: true,
                    actionsColumnIndex: 1,
                    toolbarButtonAlignment: 'left',
                    addRowPosition: 'first',
                    maxBodyHeight: calculateHeight(),
                    pageSize: 50,
                    pageSizeOptions: [5, 10, 25, 50, 100],
                    rowStyle: rowData => ({
                        backgroundColor: getColorState(rowData)
                    })
                }}
                editable={{
                    onRowAdd: onStockAdd,
                    onRowUpdate: onStockUpdate,
                    onRowDelete: onStockDelete
                }}
            />
        </div>
    );
}

export default TableStock;
